export default function Warning() {
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.19977" y="3.19995" width="17.6" height="17.6" rx="8.8" fill="#FA4569"/>
      <path d="M12 13.2L12 6.23995" stroke="white" strokeWidth="1.6" strokeLinecap="round"/>
      <ellipse cx="12" cy="16.56" rx="0.96" ry="0.96" fill="white"/>
    </svg>
  );
}